module.exports = __webpack_public_path__ + "img/27.939aa060.jpg";